<template>
    <v-tab-item :value="SUCCESS.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <h2 class="tit">낙찰 및 수수료</h2>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">낙찰 확인</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>경매 종료 후 '마이페이지'에서 결과를 확인할 수 있습니다.</span></li>
                                    <li><em>-</em><span>가입하신 이메일 주소로 &lt;낙찰확인서&gt;가 발송되며, 마이페이지에서도 확인 가능합니다.</span></li>
                                    <li><em>-</em><span>낙찰 시, 이메일로 낙찰확인서가 발송 됩니다. 혹은 홈페이지 로그인 &gt; 회원정보 &gt; 경매거래내역 &gt; 구매내역에서 낙찰 금액 및 수수료를 확인하실 수 있습니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">낙찰 수수료 (Buyer's Premium)</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>KATA 옥션의 낙찰 수수료는 10%입니다.</span></li> 
                                    <li><em>-</em><span>위의 수수료는 낙찰가격과 상관없이 일괄 적용합니다.</span></li>
                                </ul>
                                <div class="mt-10 mt-md-14">
                                    <div class="table-scroll">
                                        <div class="table-scroll__inner">
                                            <auction-commission-table></auction-commission-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">용어 정의</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>낙찰가(Hammer Price) : 경매사가 낙찰봉을 두드리면서 낙찰된 금액 혹은 온라인 입찰자가 입력(투찰)한 금액</span></li>
                                    <li><em>-</em><span>구매가(Purchase Price) : 낙찰가(Hammer Price) + 낙찰 수수료(Buyer's Premium) + 부가가치세(VAT)가 합산된 금액</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">입금 기한</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>낙찰자는 낙찰일로부터 7일 이내에, 낙찰가와 낙찰수수료, 부가가치세를 합친 구매대금을 당사로 지불하여야 합니다.</span></li>
                                    <li><em>-</em><span>낙찰가가 3억 이상일 경우, 낙찰 일로부터 7일 이내 총 구매대금의 50%를 선납해 주시고, 나머지 50%는 낙찰 일로부터 21일 이내에 완납해주시기 바랍니다.</span></li>
                                    <li><em>-</em><span>구매대금의 입금을 완료 하신 후에 작품을 운송하시기 바랍니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">입금 방법</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>구매대금은 현금, 자기앞수표, 계좌이체 등으로 지급하실 수 있습니다.</span></li>
                                    <li><em>-</em><span> 낙찰 수수료에 한해서는 신용카드 결제가 가능합니다. (신용카드로 결제하실 수 있습니다)</span></li>
                                    <li><em>-</em><span>신용카드로 결제하실 경우는 당사를 방문하셔야 가능합니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">계좌 번호</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>새마을금고 9003-2563-94153 황규성(키시 앤 캐터) (입금 후 전화 확인 바랍니다)</span></li>
                                    <li><em>-</em><span>이체 시 낙찰자와 송금계좌 예금주가 다른 경우, 반드시 입금 통장 표시에 낙찰자명 기재 부탁 드립니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">낙찰 철회 불가 및 위약금</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>낙찰자는 낙찰을 철회할 수 없습니다.</span></li>
                                    <li><em>-</em><span>낙찰 철회는 신의성실의 원칙에 반하며, 다른 입찰자 및 당사에 있어서, 막대한 기회 손실 비용이 발생합니다.</span></li>
                                    <li><em>-</em><span>부득이 철회를 하는 경우, 낙찰일로부터 7일 이내에 서면으로 철회의사를 통보한 후 위탁자의 동의하에 낙찰철회를 결정합니다.</span></li>
                                    <li>
                                        <em>-</em>
                                        <span>
                                            아울러, 낙찰자는 위약금으로 낙찰가의 30%에 해당하는 금액을 낙찰일로부터 7일 이내에 납부하여야 합니다.<br/>
                                            <div class="mt-4">
                                                <v-btn small text height="auto" color="grey-68" to="/auction-policy" class="pa-0 v-btn--none-active-bg"><strong>경매약관 바로보기</strong><v-icon>mdi-menu-right</v-icon></v-btn>
                                            </div>
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            <v-divider class="grey-cb my-30 my-md-36"></v-divider>

                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Deposit deadline</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>The successful bidder must pay full payment including the Hammer Price, Buyer's Premium, and Value-added tax, to Kata Auction with in 7 days from the close of the auction.</span></li>
                                     <li><em>-</em><span>If the Hammer Price is 300 million won or more, please prepay 50% of full payment within 7 days from  the close of the auction., and the remaining 50% within 21 days from  the close of the auction.</span></li>
                                     <li><em>-</em><span>Please ship the work(s) after full payment is completed.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Deposit method</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Payment can be rendered in cash, bank checks, or wire transfer.</span></li>
                                    <li><em>-</em><span>Credit cards are accepted for buyer's premiums only<br/>※ credit card payments must be done in person at our location</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Account number</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Korean Federation of Community Credit Cooperatives (KFCC) 9003-2563-94153 Hwang Kyu-Seong(KICI & KATA) (Please confirm by phone after deposit)</span></li>
                                    <li><em>-</em><span>If the wire transfer is made under a different name from the successful bidder, please make sure to note the name of the successful bidder in the wire transfer details.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Cancellation of successful bid and penalty</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Successful bids cannot be withdrawn or cancelled.</span></li>
                                    <li><em>-</em><span>Withdrawal or cancellation of a successful bid is against the principle of good faith, and for other bidders and the KATA Auction, huge opportunity loss costs occur.</span></li>
                                    <li><em>-</em><span>In the case of unavoidable circumstances, the buyer and KATA Auction must agree on the withdrawal or cancellation in writing beforehand.</span></li>
                                    <li><em>-</em><span>Also, the buyer must, within 7 days from the date of the auction, deliver the intent to withdraw or cancel the winning bid in writing and pay the amount equal to 30% of the hammer price.<br/>※ Link to (View Auction Terms and Conditions)</span></li>
                                </ul>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { HOW_TO_BID_TABS } from "@/assets/variables";
const { SUCCESS } = HOW_TO_BID_TABS;

import AuctionCommissionTable from "@/components/client/auction/auction-commission-table.vue";
export default {
    components: {
        AuctionCommissionTable,
    },
    data() {
        return {
            SUCCESS,
        };
    },
};
</script>

<style></style>
